exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".app-info[data-v-cb48917c]{padding:10px}.toolbar[data-v-cb48917c]{padding:10px}", ""]);

// exports
